module.exports = __webpack_public_path__ + "img/24-hours-support.7c62cee9.svg";